import { render, staticRenderFns } from "./itDeclarationStatmentNewRegimePopup.vue?vue&type=template&id=26a96380&scoped=true"
import script from "./itDeclarationStatmentNewRegimePopup.vue?vue&type=script&lang=js"
export * from "./itDeclarationStatmentNewRegimePopup.vue?vue&type=script&lang=js"
import style0 from "./itDeclarationStatmentNewRegimePopup.vue?vue&type=style&index=0&id=26a96380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a96380",
  null
  
)

export default component.exports